import React from 'react';

import { ThemeProvider } from '@creditas/stylitas';
import { Global } from '@creditas/global';
import tokens from '@creditas/tokens';

import NavBar from './components/navbar';

interface InNavbarPage {
  goTo: string;
}

const mfNavbarPage: React.FC<InNavbarPage> = (props: InNavbarPage) => {
  return (
    <ThemeProvider theme={{ ...tokens }}>
      <Global />
      <NavBar {...props} />
    </ThemeProvider>
  );
};

export default mfNavbarPage;
